import { useEffect } from 'react';

export default function useMobileViewport() {
  useEffect(() => {
    const viewportMetaTag = document.createElement('meta');
    viewportMetaTag.id = 'mobile-viewport';
    viewportMetaTag.name = 'viewport';
    viewportMetaTag.content = 'width=device-width, initial-scale=1';
    document.querySelector('head').appendChild(viewportMetaTag);

    const appContainerNode = document.getElementById('app-container');
    if (appContainerNode) {
      appContainerNode.style.overflowX = 'hidden';
    }

    return () => {
      const createdMetaTag = document.getElementById('mobile-viewport');
      createdMetaTag.content = 'initial-scale=0';
      document.querySelector('head').removeChild(createdMetaTag);
      if (appContainerNode) {
        appContainerNode.style.overflowX = 'auto';
      }
    };
  }, []);
}
